import CityPageTemplate from "../city-template/CityPageTemplate";
import { bayCityConfig } from "./data";

export default function BayCityPage() {
  return <CityPageTemplate config={bayCityConfig} />;
}